import script from "./user-select.vue?vue&type=script&setup=true&lang=js"
export * from "./user-select.vue?vue&type=script&setup=true&lang=js"

import "./user-select.vue?vue&type=style&index=0&id=5e9e9be2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9e9be2"]])

export default __exports__